import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFrown, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import './css/NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <FontAwesomeIcon icon={faFrown} className="not-found-icon" />
        <h1 className="not-found-text">404</h1>
        <h2 className="not-found-subtext">Page Not Found</h2>
        <p className="not-found-description">
          Oops! The page you are looking for does not exist.
        </p>
        <Link to="/" className="back-home-link">
          <FontAwesomeIcon icon={faArrowLeft} className="back-home-icon" />
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
